import { createFileRoute, redirect } from '@tanstack/react-router'
import { PilihDesa } from '../pages/PilihDesa'

export const Route = createFileRoute('/pilih-desa')({
  beforeLoad: async () => {
    try {
      const res = await fetch('/api/users/me', { credentials: 'include' })
      if (!res.ok) throw new Error('not authenticated')
      const user = await res.json()
      if (!user) throw new Error('no user')

      // platform_admin / is_qc → platform
      if (user.role === 'platform_admin' || user.is_qc) {
        throw redirect({ to: '/platform' })
      }

      // Sudah pilih desa → desa dashboard atau overview
      if (user.desa_id && user.desa?.slug) {
        if (user.status === 'approved') {
          throw redirect({ to: `/desa/${user.desa.slug}/dashboard` as any })
        }
        throw redirect({ to: `/desa/${user.desa.slug}` as any })
      }
      if (user.desa_id) {
        throw redirect({ to: '/parkir' })
      }

      return { user }
    } catch (e) {
      if ((e as any)?.to) throw e
      throw redirect({ to: '/login' })
    }
  },
  component: PilihDesa,
})
